import styled from 'styled-components';


export const Img = styled.img`
  height: 24px;
  width: 28px;
  display: inline-block;
`

export const Spacer = styled.div`
  width: 20px;
  display: inline-block;
`
